import { EMAIL_REGEX } from '@/shared/constants/validation';

// Canonical email normalization for any sink that isn't already going through a zod email schema (which .trim()s).
export function normalizeEmail(value: string): string {
	return value.trim();
}

export function validateEmail(value: string): string {
	if (!value.trim()) {
		return 'Email is required';
	}
	if (!EMAIL_REGEX.test(value)) {
		return 'Please enter a valid email address';
	}
	return '';
}
